/**
 * Synchronous queries are meant to be used on context where async queries can't work, for example
 * for validation queries that need to be run before opening a new tab/window, where async queries
 * are a clue for the browser to interpret the new tab/window as a pop-up to be blocked.
 *
 * Differences:
 *  - to NOT use gql (creates an object)
 *  - do NOT use fragments that use gql
 *  - use executeGraphQLQuerySync instead of standard executeGraphQLQuery
 */

export interface ISyncQueryOptions {
  query: string;
  variables?: any;
  rootField: string;
}

export function getProjectFilesDataForSendingToGenomeViewerOptions(fileIds: number[]) {
  return {
    query: `
      query getFilesDataForSendingToGenomeViewer($fileIds: [Long]!) {
        projectFilesById(fileIds: $fileIds) {
          id
          fileName
          fileBrowseType
          isProtected
          isEditable
          indexingStatus
          description
          url
          organisms {
            id
            name
            identifier
          }
        }
      }
    `,
    variables: {
      fileIds: fileIds,
    },
    rootField: "projectFilesById",
  };
}
